const overseasServiceBookingRouter = {
  route: null,
  name: null,
  title: '服务预约',
  type: 'folder',
  icon: 'iconfont el-icon-service',
  filePath: 'view/overseas_service_booking/',
  order: 5,
  inNav: true,
  permission: ['查询服务预约'],
  children: [
    {
      title: '预约处理管理',
      type: 'view',
      name: 'overseasServiceBookingList',
      route: '/overseas-service-booking/list',
      filePath: 'view/overseas_service_booking/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-date',
      permission: ['查询服务预约'],
    },
  ],
}

export default overseasServiceBookingRouter
